import Decimal from 'decimal.js';

export default function sumValues(arr, key) {
	if (!arr) return 0;
	// return arr.reduce((p, c) => c[key] ? p.plus(c[key]) : p, new Decimal(0)).toNumber();
	return arr.reduce((p, c) => c[key] ? p.plus(c[key]) : p, new Decimal(0)).toNumber();
}